<template>
  <button
    :type="type"
    :class="['btn', size === 'sm' ? 'btn-sm' : '', variant]"
    :disabled="busy || disabled"
    @click="$emit('click', $event)"
  >
    <span v-if="busy" class="spinner-border spinner-border-sm me-1"></span>
    <FontAwesomeIcon v-else-if="icon" :icon="icon" class="me-1" />
    <slot />
  </button>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    busy: boolean;
    icon?: string;
    variant?: string;
    size?: "sm" | "md";
    type?: "button" | "submit";
    disabled?: boolean;
  }>(),
  {
    icon: undefined,
    variant: "btn-outline-primary",
    size: "sm",
    type: "button",
    disabled: false,
  }
);

defineEmits<{
  click: [event: MouseEvent];
}>();
</script>
